<template>
  <div>
    <div class="my-2">
      <b-form-select
        v-model="selectedOrg"
        :options="optionsOrg"
        v-b-tooltip.hover
        title="Организация"
        id="orgSelect"
        @input="classChanged" />
      <b-form-select
        v-model="selectedClass"
        :options="optionsClass"
        v-b-tooltip.hover
        @input="classChanged"
        title="Класс"
        id="classSelect" />
    </div>
    <ag-grid-vue
      v-show="rowData && rowData.length"
      style="height: 300px !important;"
      class="ag-theme-material col-md-12 ag-grid-event-members"
      :columnDefs="columnDefs"
      :gridOptions="gridOptions"
      :rowData="rowData"
      :suppressRowClickSelection="true"
      rowSelection="multiple"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
    >
    </ag-grid-vue>
    <b-alert :show="rowData && !rowData.length">
      Нет участников из выбранной организации
    </b-alert>
    <div v-show="!rowData" class="text-center my-3">
      <b-spinner variant="primary" />
    </div>
    <div style="margin-left: 16px; margin-top: 16px" v-if="hasRole('classroom-teacher')">
      <b-button
        variant="primary"
        @click="saveChangesEvenMembers"
        :disabled="selectedOrg !== currUser.organizationId"
        class="buttonFormEventMembers"
      >
        Сохранить изменения
      </b-button>
      <b-button
        variant="outline-primary"
        @click="cancelChangesEvenMembers"
        :disabled="(selectedOrg !== currUser.organizationId) || !isChanged"
        class="buttonFormEventMembers ml-1"
      >
        Отменить изменения
      </b-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapActions } from 'vuex'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { roles } from '@/config/roles'

export default {
  name: 'ModalEventMembers',
  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    title: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      isChanged: false,
      selectedOrg: null,
      selectedClass: ['10', '11'],
      optionsClass: [
        { value: ['10', '11'], text: 'Все' },
        { value: ['10'], text: '10' },
        { value: ['11'], text: '11' }
      ],
      rowData: null,
      columnDefs: [],
      gridApi: null,
      columnApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU
      },
      filters: [{
        param: 'organizationId',
        needle: ['']
      }],
      columnsForTeacher: [
        {
          headerName: '№',
          field: 'numb',
          suppressSizeToFit: true,
          width: 65
        },
        {
          headerName: 'Фамилия',
          field: 'surname',
          width: 170
        },
        {
          headerName: 'Имя',
          field: 'name',
          width: 170
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          width: 170
        },
        {
          headerName: 'Участие',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 140
        }
      ],
      columnsForCurator: [
        {
          headerName: '№',
          field: 'numb',
          suppressSizeToFit: true,
          width: 70
        },
        {
          headerName: 'Фамилия',
          field: 'surname',
          width: 215
        },
        {
          headerName: 'Имя',
          field: 'name',
          width: 215
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          width: 215
        }
      ],
      selectedStudents: []
    }
  },
  mounted() {
    this.fetchOrgsForEvent({ id: this.$route.params.eventId || this.$route.params.id }).then(() => {
      if (this.hasRole(roles.teacher)) {
        this.selectedOrg = this.orgs.find((p) => p.id === this.currUser.organizationId).id
      } else {
        this.selectedOrg = this.optionsOrg[0].value
      }
    })
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser',
      users: 'users/getUsers',
      orgs: 'dicts/getOrganizations',
      orgsWithCounts: 'content/getOrgsForEvent'
    }),
    optionsOrg() {
      if (this.orgs && this.orgs.length && this.orgsWithCounts && this.orgsWithCounts.length) {
        if (this.hasRole(roles.curator)) {
          return this.orgsWithCounts.map((org) => ({
            value: org.organizationId,
            text: `${this.orgs.find((p) => p.id === org.organizationId).title} (${
              org.studentEventMembersCount
            }/${org.studentFromOrganizationCount})`
          }))
        } if (this.hasRole(roles.teacher)) {
          return [{
            value: this.currUser.organizationId,
            text: `${this.orgs
              .find((p) => p.id === this.currUser.organizationId).title} (${
              this.orgsWithCounts
                .find((p) => p.organizationId === this.currUser.organizationId)
                .studentEventMembersCount
            }/${this.orgsWithCounts
              .find((p) => p.organizationId === this.currUser.organizationId)
              .studentFromOrganizationCount
            })`
          }]
        }
      }
      return []
    }
  },
  methods: {
    onSelectionChanged() {
      this.isChanged = false
      const selectedRows = this.gridApi.getSelectedNodes()
      const newSelected = selectedRows.map((row) => row.data.id)
      if (this.selectedStudents.length !== newSelected.length) {
        this.isChanged = true
      } else {
        newSelected.forEach((id) => {
          if (!this.selectedStudents.includes(id)) {
            this.isChanged = true
          }
        })
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      this.updateCheckboxes()
    },
    saveChangesEvenMembers() {
      const selectedStudents = this.gridApi.getSelectedNodes()
      const dataForUpdate = []
      for (let i = 0; i < this.rowData.length; i++) {
        dataForUpdate.push({
          userId: this.rowData[i].id,
          userIsMember: !!(selectedStudents.filter((p) => p.data.id === this.rowData[i].id).length)
        })
      }
      this.updateMemberStatus({
        users: dataForUpdate,
        eventId: this.$route.params.eventId || this.$route.params.id
      }).then((response) => {
        if (response.status === 204) {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Участники успешно изменены.',
            time: 10
          })
          this.$emit('closeEventModal')
          const selectedRows = this.gridApi.getSelectedNodes()
          const newSelected = selectedRows.map((row) => row.data.id)
          const addedStudents = []
          const removedStudents = []
          this.users.forEach((user) => {
            if (this.selectedStudents.includes(user.id) && !newSelected.includes(user.id)) {
              removedStudents.push(user.id)
            } else if (!this.selectedStudents.includes(user.id) && newSelected.includes(user.id)) {
              addedStudents.push(user.id)
            }
          })
        } else {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'Во время изменений участников произошла ошибка.',
            time: 10
          })
        }
        this.getData()
      })
    },
    cancelChangesEvenMembers() {
      this.updateCheckboxes()
      this.$emit('closeEventModal')
    },
    updateCheckboxes() {
      this.gridApi.forEachNode((node) => {
        if (node.data.isMember) {
          node.setSelected(true)
        } else {
          node.setSelected(false)
        }
      })
      const selectedRows = this.gridApi.getSelectedNodes()
      this.selectedStudents = selectedRows.map((row) => row.data.id)
    },
    getData() {
      this.rowData = null
      this.changePageSize(this.orgsWithCounts
        .find((p) => p.organizationId === this.selectedOrg)
        .studentFromOrganizationCount)
      this.fetchUsers({
        filters: [
          {
            param: 'organizationId',
            needle: [this.selectedOrg]
          },
          {
            param: 'class',
            needle: this.selectedClass,
            isStrict: true
          },
          {
            param: 'active',
            needle: true,
            isStrict: false
          }]
      }).then(() => {
        const ids = this.users.map((user) => user.id)
        this.fetchMemberStatus({ ids, eventId: this.$route.params.eventId || this.$route.params.id })
          .then((usersWithStatus) => {
            const dataForTable = usersWithStatus
              .filter((user) => user.active)
              .map((user) => ({
                surname: user.surname,
                name: user.name,
                midname: user.midname,
                id: user.id,
                isMember: !!(user.participatedEvents.length)
              }))
            if (this.hasRole(roles.curator)
              && !(this.hasRole(roles.teacher)
                && this.currUser.organizationId === this.selectedOrg)) {
              this.columnDefs = this.columnsForCurator
              this.rowData = dataForTable.filter((p) => p.isMember === true)
            } else {
              this.columnDefs = this.columnsForTeacher
              this.rowData = dataForTable
            }
            this.rowData = _.sortBy(this.rowData, 'surname')
            for (let i = 0; i < this.rowData.length; i++) {
              this.rowData[i].numb = i + 1
            }
            setTimeout(() => {
              this.updateCheckboxes()
              this.fetchOrgsForEvent({ id: this.$route.params.eventId || this.$route.params.id })
            }, 0)
          })
      })
    },
    classChanged() {
      this.getData()
    },
    ...mapActions({
      fetchUsers: 'users/fetchUsers',
      changePageSize: 'users/changePageSize',
      fetchOrgsForEvent: 'content/fetchOrgsForEvent',
      fetchMemberStatus: 'content/fetchMemberStatus',
      pushToasts: 'toasts/pushToasts',
      updateMemberStatus: 'content/updateMemberStatus'
    })
  }
}
</script>

<style>
  .ag-grid-event-members .ag-row .ag-cell {
    white-space: normal !important;
    font-size: 13px !important;
    padding-left: 15px !important;
    text-align: left !important;
    justify-content: left;
  }
  .ag-grid-event-members .ag-body-viewport{
    overflow-y: scroll;
    border-bottom: 1px solid #017ac3 !important;
  }
  .ag-grid-event-members .ag-selection-checkbox {
    margin: auto
  }
  .ag-grid-event-members .ag-header-viewport {
    border-top: 1px solid #017ac3 !important;
  }
  #orgSelect {
    display: inline-block;
    width: 69%;
    margin-right: 2%;
  }
  #classSelect {
    display: inline-block;
    width: 29%;
  }
  .buttonFormEventMembers {
    width: 49%;
  }
</style>
